import React from "react"
import { createRoot } from "react-dom/client"

const AntLess = process.env.NODE_ENV === "development" && require("antd/dist/antd.less")
const App = require("./App").default

// const rootElement = document.getElementById("root")

// if (rootElement.hasChildNodes()) {
//   ReactDOM.hydrate(<App />, rootElement)
// } else {
//   ReactDOM.render(<App />, rootElement)
// }

const root = createRoot(document.getElementById("root"))

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
